<template>
  <div class="video-page">
    <div class="left">
      <ul>
        <li v-for="(device, index) in videoList" :key="index">
          <div @click="setDeviceToBind(device.number,device.channel)">{{device.title}}({{device.name}})</div>
        </li>
      </ul>
    </div>
    <div class="center" :class="`videos-${videos.length}`">
      <video-box
        ref="child"
        class="video-preview"
        :class="{ 'is-binding': deviceToBind }"
        v-for="(video, index) in videos"
        :key="index"
        :activated="activatedVideo === video"
        :video="video"
        :rnd="video.rnd"
        @click.native="deviceToBind ? bindDevices(video) : activeVideo(video)">
      </video-box>
    </div>
    <div class="right">
      <div class="count-control">
        <div class="count-control-1" @click="createVideos(1)">
          <div></div>
        </div>
        <div class="count-control-4" @click="createVideos(4)">
          <div v-for="i in [1,2,3,4]" :key="i"></div>
        </div>
        <div class="count-control-9" @click="createVideos(9)">
          <div v-for="i in [1,2,3,4,5,6,7,8,9]" :key="i"></div>
        </div>
      </div>
      <video-control :video="activatedVideo"></video-control>
    </div>
  </div>
</template>
<script>
import cameraApi from "@/api/light/camera";
import videoBox from '@/components/video/VideoBox.vue'
import videoControl from '@/components/video/VideoControl.vue'
export default {
  components: {
    videoBox,
    videoControl
  },
  data () {
    return {
      videoList: [],
      videos: [],
      deviceToBind: null,
      activatedVideo: {},
      controlSpeed: 50
    }
  },
  mounted () {
    this.getLeftList()
  },
  methods: {
    getLeftList() {
      cameraApi.cameraList({
        page: 1,
        pageSize: 200,
      }).then((res) => {
        if (res.data.code === 1000) {
          this.videoList = res.data.data.list;
          if(res.data.data.list.length) {
            this.getFirstVideo(res.data.data.list[0].number, res.data.data.list[0].channel)
          }
        }
      });
    },
    getFirstVideo(number, channel){
      cameraApi.cameraInfo({
        number: number,
        channel: channel
      }).then((res) => {
        if (res.data.code === 1000) {
          const {camera_type, channel, access_token} = res.data.data
          this.activatedVideo = {
            index: 0,
            number: number,
            camera_type: camera_type,
            channel: channel,
            access_token: access_token,
            rnd: Math.random()
          }
          this.createVideos(4)
        }
      });
    },
    createVideos (count) {
      if ([1, 4, 9].indexOf(count) < 0) {
        return
      }
      if (this.activatedVideo && count <= this.activatedVideo.index) {
        this.activatedVideo = {}
      }
      if (count > this.videos.length) {
        for (let i = this.videos.length; i < count; i++) {
          this.videos.push({
            index: i,
            number: '',
            camera_type: 1,
            channel: 1,
            access_token: '',
            rnd: Math.random()
          })
        }
      } else if (count < this.videos.length) {
        const videos = []
        for (let i = 0; i < count; i++) {
          videos.push(this.videos[i])
        }
        this.videos = videos
      }
    },
    setDeviceToBind (number,channel) {
      if (this.deviceToBind && this.deviceToBind.number === number) {
        this.deviceToBind = null
      } else {
        cameraApi.cameraInfo({
          number: number,
          channel: channel
        }).then((res) => {
          if (res.data.code === 1000) {
            const {camera_type, channel, access_token} = res.data.data
            this.deviceToBind = {
              number: number,
              camera_type: camera_type,
              channel: channel,
              access_token: access_token,
            }
            this.activatedVideo = this.deviceToBind
          }
        });
      }
    },
    bindDevices (video) {
      video.rnd = Math.random()
      video.number = this.deviceToBind.number //设备序列号
      video.camera_type = this.deviceToBind.camera_type //设备序列号
      video.channel = this.deviceToBind.channel //通道号
      video.access_token = this.deviceToBind.access_token //通道号
      this.deviceToBind = null
    },
    activeVideo (video) {
      if (this.activatedVideo === video) {
        this.activatedVideo = null
      } else {
        this.activatedVideo = video
      }
    }
  }
}
</script>

<style scoped>
.video-page {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
}
.left {
  position: fixed;
  top: 60px;
  left: 0px;
  bottom: 0px;
  width: 180px;
  background: #333;
  color:#fff;
  overflow-y: auto;
  overflow-x: hidden;
}
.left ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.left ul div {
  line-height:1.4;
  padding: 10px 20px; 
  box-sizing: border-box;
  font-size: 14px;
  cursor: pointer;
  white-space: pre-line !important;
  word-break: break-all !important;
  word-wrap: break-word !important;
}
.left ul div:hover {
  background: rgba(255, 255, 255, 0.1);
}

.left > ul {
  font-size: 16px;
  margin: 15px 0;
}
.center {
  position: fixed;
  top: 60px;
  left: 180px;
  right: 180px;
  bottom: 0;
}
.right {
  position: fixed;
  top: 60px;
  bottom: 0px;
  right: 0px;
  width: 180px;
  background: #333;
  color: #fff;
}
.right .count-control {
  border-bottom: 1px solid #696969;
  overflow: hidden;
  text-align: center;
  height: 80px;
}
.right .count-control > div {
  display: inline-block;
  width: 36px;
  height: 36px;
  margin: 20px 5px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #696969;
  background: #23252a;
  box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}
.right .count-control > div > div {
  float: left;
  border: 1px solid #696969;
  margin: -1px;
}
.right .count-control-1 > div {
  width: 36px;
  height: 36px;
}
.right .count-control-4 > div {
  width: 18px;
  height: 18px;
}
.right .count-control-9 > div {
  width: 12px;
  height: 12px;
}
.video-container {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
}
.videos-1 .video-container {
  width: 100%;
  height: 100%;
}
.videos-4 .video-container {
  width: 50%;
  height: 50%;
}
.videos-9 .video-container {
  width: 33.333333%;
  height: 33.333333%;
}
.video-preview.is-binding {
  cursor: pointer;
}
.video-preview.is-binding:before {
  content: '在这里显示';
  display: block;
  position: absolute;
  font-size: 24px;
  color: #fff;
  background: #000;
  width: 100%;
  height: 100%;
  text-align: center;
  box-sizing: border-box;
  padding-top: 2em;
  opacity: 0.3;
  z-index: 2;
}
.video-preview.is-binding:hover:before {
  opacity: 0.6;
}
.right .count-control {
  border-bottom: 1px solid #696969;
  overflow: hidden;
  text-align: center;
  height: 80px;
}
.right .count-control > div {
  display: inline-block;
  width: 36px;
  height: 36px;
  margin: 20px 5px;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #696969;
  background: #23252a;
  box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}
.right .count-control > div > div {
  float: left;
  border: 1px solid #696969;
  margin: -1px;
}
.right .count-control-1 > div {
  width: 36px;
  height: 36px;
}
.right .count-control-4 > div {
  width: 18px;
  height: 18px;
}
.right .count-control-9 > div {
  width: 12px;
  height: 12px;
}
.autocomplete-wrapper {
  position: relative;
}
.autocomplete-wrapper .el-input input {
  border-radius: 18px;
  padding-right: 35px;
}
.autocomplete-search {
  position: absolute;
  top: 10px;
  right: 30px;
  color: #333;
}
</style>